import { render, staticRenderFns } from "./VideoCase.vue?vue&type=template&id=d0efdbde&scoped=true"
import script from "./VideoCase.vue?vue&type=script&lang=js"
export * from "./VideoCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0efdbde",
  null
  
)

export default component.exports